import { render, staticRenderFns } from "./RecoveryPasswordComercioAsociado.vue?vue&type=template&id=130880a0&"
import script from "./RecoveryPasswordComercioAsociado.vue?vue&type=script&lang=js&"
export * from "./RecoveryPasswordComercioAsociado.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryPasswordComercioAsociado.vue?vue&type=style&index=0&id=130880a0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports